import { useAuth } from "../../auth/AuthContext";
import { TabbedPage } from "../../components/TabbedPage";
import { OnlineOrdersPage } from "../orders/OnlineOrdersPage";
import { ReturnsPage } from "../returns/ReturnsPage";
import { ShipmentsPage } from "../shipments/ShipmentsPage";
import { ROLES_WITH_ONLINE_ORDERS_ACCESS } from "../../roles/permissions";

/** Merged Online Orders + Returns + Shipments. Unlike the other merged pages, these
 * three are NOT gated identically — Returns/Shipments are open to every app-access role,
 * but Online Orders is OWNER/ECOM_MGR only — so this page filters its own tab list by
 * role rather than relying solely on the (necessarily broader) route-level guard. */
export function FulfillmentPage() {
  const { user } = useAuth();
  const showOnlineOrders = user ? ROLES_WITH_ONLINE_ORDERS_ACCESS.includes(user.role) : false;

  return (
    <TabbedPage
      title="Fulfillment"
      defaultTab={showOnlineOrders ? "orders" : "returns"}
      tabs={[
        ...(showOnlineOrders ? [{ key: "orders", label: "Online Orders", content: <OnlineOrdersPage /> }] : []),
        { key: "returns", label: "Returns", content: <ReturnsPage /> },
        { key: "shipments", label: "Shipments", content: <ShipmentsPage /> },
      ]}
    />
  );
}
